import 'jquery';

global.jQuery = $;
global.jquery = $;
global.$ = $;

import svg4everybody from 'svg4everybody/dist/svg4everybody';
import objectFitImages from 'object-fit-images';
import LazyLoad from 'lazyload/lazyload';

import '../scss/common.scss';

$(document).ready(function() {
	// adds SVG External Content support to all browsers
	svg4everybody();

	// Polyfill object-fit/object-position on <img>
	objectFitImages();

	// lazyload
	let images = document.querySelectorAll('img.lazyload');
	new LazyLoad(images);

	window.LazyLoad = LazyLoad;

	if ($('.js-cookie_notification').length > 0) {
		let cookieDate = localStorage.getItem('cookieDate');
		let cookieNotification = document.querySelector('.js-cookie_notification');

		let cookieBtnAccept = cookieNotification.querySelector('.js-cookie_accept');
		let cookieBtnClose = cookieNotification.querySelector('.js-cookie_close');
		// if cookie acept missing - show notification
		if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
			// document.querySelector('.page').classList.add('dark-theme');
			cookieNotification.classList.add('show');
		}

		// cookie accept btn click
		cookieBtnAccept.addEventListener('click', function(){
			localStorage.setItem( 'cookieDate', Date.now() );
			cookieNotification.classList.remove('show');
		})

		cookieBtnClose.addEventListener('click', function(){
			cookieNotification.classList.remove('show');
		})
	}
});

$(window).on('load', function() {

	console.log('loaded');

	setTimeout(() => {
		let img = document.querySelectorAll("img.load");
		let lazy = new LazyLoad(img);
		lazy.loadImages();
	}, 1000);
});

import '~components/notify/notify'
import '~components/menu/menu'
import '~components/footer/footer'
import '~components/hamburger/hamburger'
import '~components/search/search'
import '~components/scrollto/scrollto'
import '~components/favorites/favorites'
import '~components/minicart/minicart'
import '~components/basket/basket'
import '~components/counters/counters'


